import {makeStyles} from "@material-ui/core"
export const useStyles = makeStyles({
    root: {
      marginBottom: 25,
      minWidth: "48%",
      boxShadow:"1px 1px 5px gray",

    },
    rootMedia:{ 
      maxWidth: "100%",
      minWidth: "100%",
      marginBottom: 25,
     },
     tablet:{
      maxWidth: "48%",
      minWidth: "48%",
      marginBottom: 25,
     },
  
    media: {
      height: "100%",
    },
  });
  